import React from 'react';
import { Datagrid, List, TextField, FunctionField } from 'react-admin';
import { DEFAULT_LIST_PERPAGE } from '../../utils/constants';
import { leadImportFilters } from './leadImportFilters.component';
import { leadImportFields } from '../leadImports.model';
import { StatusChip, DateTimeField } from './field';
import { MetricsDisplay } from './report';
import ListActions from './ListActions.component';
import ActionsMenu from './ActionsMenu.component';

export const LeadImportList = () => (
  <List
    perPage={DEFAULT_LIST_PERPAGE}
    sort={{ field: 'created_at', order: 'DESC' }}
    actions={<ListActions />}
    filters={leadImportFilters}
    title="Lead Import History"
    bulkActionButtons={false}
    empty={false}
  >
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source={leadImportFields.id} label="Batch ID" />
      <TextField source={leadImportFields.filename} label="Filename" />
      <TextField source={leadImportFields.sourceOrg} label="Source" />
      <DateTimeField source={leadImportFields.createdAt} label="Upload Date" />
      <StatusChip label="Status" />
      <MetricsDisplay label="Records" variant="simple" />
      <FunctionField
        label="Actions"
        render={(record) => <ActionsMenu record={record} />}
      />
    </Datagrid>
  </List>
);

export default LeadImportList;
